import { Button, ConfigProvider } from "antd";
import agroUniaoLogo from "../images/agro-uniao.png";
import { WhatsAppOutlined } from "@ant-design/icons";
export default function AgroUniao() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        gap: 80,
      }}
    >
      <img src={agroUniaoLogo} width={400} alt="AgroUniao Logo" />
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#37ee37",
            colorTextBase: "#fff",
          },
        }}
      >
        <Button
          type="primary"
          color="pink"
          style={{ marginLeft: 20, color: "#000" }}
          href="https://api.whatsapp.com/send/?phone=5579998979695"
          target="_blank"
        >
          <WhatsAppOutlined style={{ marginRight: 8 }} />
          Fale conosco
        </Button>
      </ConfigProvider>
    </div>
  );
}
